import { CalendarCheck, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { Magnetic } from "@/components/Magnetic";
import { useSettings } from "@/context/SettingsContext";
import { whatsappLink } from "@/lib/contact";

const BG = "/img/cta-bg.webp";

export default function FinalCta() {
  const settings = useSettings();
  const wa = whatsappLink(settings, "Merhaba, aracım için en doğru koruma planını belirlemek istiyorum.");

  return (
    <section data-testid="final-cta" className="relative grain overflow-hidden py-28 sm:py-40">
      <div className="absolute inset-0">
        <img src={BG} alt="Premium araç koruma" className="h-full w-full object-cover opacity-25 grayscale-[0.3]" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#070707] via-[#070707]/85 to-[#070707]" />
        <div className="pointer-events-none absolute left-1/2 top-1/3 h-[24rem] w-[24rem] -translate-x-1/2 rounded-full bg-gold/10 blur-[150px]" />
      </div>
      <div className="container-x relative z-10">
        <Reveal className="mx-auto max-w-3xl text-center">
          <span className="font-oswald text-xs font-bold uppercase tracking-[0.3em] text-gold">Hazır mısınız?</span>
          <h2 className="mt-6 font-display text-3xl font-semibold leading-[1.08] tracking-tight text-white sm:text-4xl lg:text-5xl">
            Aracınız için en doğru <span className="text-gold-gradient">koruma planını</span> birlikte belirleyelim.
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base text-neutral-300">
            Ücretsiz değerlendirme için bize ulaşın. Aracınıza değer katmanın en doğru yolu bir mesaj uzağınızda.
          </p>
          <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Magnetic>
              <Link
                to="/randevu"
                data-testid="final-cta-randevu"
                className="inline-flex items-center justify-center gap-2.5 bg-gold px-8 py-4 font-oswald text-sm font-bold uppercase tracking-[0.12em] text-black shadow-[0_12px_36px_-10px_rgba(247,195,0,0.6)] transition-colors hover:bg-gold-300"
              >
                <CalendarCheck className="h-[18px] w-[18px]" /> Ücretsiz Randevu Al
              </Link>
            </Magnetic>
            <a
              href={wa}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-cta-whatsapp"
              className="inline-flex items-center justify-center gap-2.5 border border-white/15 px-8 py-4 font-oswald text-sm font-semibold uppercase tracking-[0.12em] text-white glass-light transition-colors hover:border-gold/50"
            >
              <MessageCircle className="h-[18px] w-[18px] text-gold" /> WhatsApp'tan Yaz
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
